import { DetailedSettings } from 'handsontable/plugins/nestedHeaders';

export function isColSpanHeader(arg: any): arg is DetailedSettings {
  return arg.label !== undefined;
}
